import React, { useState } from 'react'
import Fill_in from './Fill_in'
import Attachment_document from './Attachment_document'
import Back_ID from './Back_ID'
import Front_ID from './Front_ID'
import Stk from './Stk'
import Cv from './Cv'

function Jobs({ms, type, uniq}) {
    const [fill, setFill] = useState(true)
    const [Back_IDs, setBackid] = useState(false)
    const [Front_IDs, setFrontid] = useState(false)
    const [Attachment_documents, setAttachmentdoc] = useState(false)
    const [cv, setCv] = useState(false)
    const [pay, setPay] = useState(false)
  return (
    <div className='job_part'>
      
      {fill?(<div><Fill_in setBackid={setBackid} setFill={setFill} type={type} uniq={uniq} /></div>):('')}
      {Back_IDs?(<div><Back_ID setBackid={setBackid} setFrontid={setFrontid} uniq={uniq} /></div>):('')}
      {Front_IDs?(<div><Front_ID setFrontid={setFrontid} setAttachmentdoc={setAttachmentdoc} uniq={uniq} /></div>):('')}
      {Attachment_documents?(<div><Attachment_document setAttachmentdoc={setAttachmentdoc} setCv={setCv} uniq={uniq} type={type} /></div>):('')}
      {cv?(<div><Cv setCv={setCv} setPay={setPay} /></div>):('')}
      {pay?(<div><Stk setPay={setPay} ms={ms} /></div>):('')}
     


    </div>
  )
}

export default Jobs